export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/petFriendly-11cdfdbfa3225f7a3b731419469dfe08.svg";